import { useSafeState } from './use-safe-state'
/**
 * Use this hook if your component state is also updated by props.
 * The value passed in by props will be checked and if it differs the component state will be updated.
 * see also: https://reactjs.org/docs/hooks-faq.html#how-do-i-implement-getderivedstatefromprops
 *
 * @param {*} propsValue - the value passed into the component
 * @returns {Array} - Returns an array with value and setter [value, setter]
 */
function useDerivedStateFromProps(propsValue) {
    const [stateValue, setStateValue] = useSafeState(propsValue)
    const [prevValue, setPrevValue] = useSafeState(propsValue)

    if (prevValue !== propsValue) {
        setStateValue(propsValue)
        setPrevValue(propsValue)
    }

    return [stateValue, setStateValue]
}

export { useDerivedStateFromProps }
